/*!
 * @preserve
 * OUISearch.js
 * OUI Manufacture Search JS Frontend Library for dein-ip-check.de
 *
 * @version 3.0.3
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

// POST-Request Definition
interface requestGetType {
    REQUEST_TOKEN: string;
    oui: string;
}

/**
 * Führe Suche nach Vendor/OUI aus und aktualisiere Browser-History
 *
 * @param oui
 * @param page
 * @param requestToken
 */
const searchForVendor = (oui: string, page: number, requestToken: string) => {
    // Request Token und Suchbegriffen als Array zusammensetzen für AJAX POST Requst
    let requestGet: requestGetType = {
        REQUEST_TOKEN: requestToken,
        oui: oui,
    };

    // AJAX Route aus entsprechendem Data-Tag auslesen
    let actionRoute = document.createElement('a');
    actionRoute.href = $('#ouiSearchForm').attr('data-ajax');

    // Ajax request ausführen
    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: actionRoute.pathname + '?' + $.param({ "page": page }),
        data: jQuery.param(requestGet),
    })
        .done(response => {
            // AJAX-Request ausgeben
            $('#ouiSearchResult').html(response.result);

            // Aktualisiere History
            let pushUrl = document.createElement('a');
            pushUrl.href = $('#ouiSearchForm').attr('action');
            history.pushState(
                {"oui": requestGet.oui, "page": page, "html":response.result},
                null,
                `${pushUrl.pathname}?${jQuery.param({"oui": requestGet.oui, "page": page})}`
            );
        })
        .fail((jqXHR, textStatus, errorThrown) => {
            // Fehler-Handling
            $('#ouiSearchResult').html(
                `<div class='alert alert-danger' role='alert'><div id='errorText'>Fehler bei der AJAX Abfrage (${textStatus})</div></div>`
            );
            console.error(errorThrown);
        })
        .then(function() {
            // Scroll zur Anfang der Liste
            let tag = $('#ouiSearchForm');
            $('html,body').animate({ scrollTop: tag.offset().top }, 'slow');
        });
};

/**
 * History Support
 */
window.addEventListener('popstate', function (e) {
    if(e.state === null) {
        // Leeres Formular erzeugen
        $('#ouiSearchResult').html("");
        $('#oui').val("");
    } else {
        // Seiteninhalt aus der History aktualisieren
        $('#oui').val(e.state.oui);
        $('#ouiSearchResult').html(e.state.html);
    }

    // Scroll zur Anfang der Liste
    let tag = $('#ouiSearchForm');
    $('html,body').animate({ scrollTop: tag.offset().top }, 'slow');
}, {once: true});

window.onload = () => {
    const URLSearchParams = require('@ungap/url-search-params');

    let actionRoute = document.createElement('a');
    actionRoute.href = $('#ouiSearchForm').attr('data-ajax');

    /**
     * Start der initialen Suche
     */
    $('#ouiSearchForm #ctrl_submit').off('click').on('click', a => {
        a.preventDefault();

        // Ergebnisliste abrufen
        searchForVendor(
            $('#oui').val().toString(),
            1,
            $('input[name=REQUEST_TOKEN]').val().toString()
        );
    });

    /**
     * Klick auf einer der Pagination-Links
     */
    $('#ouiSearchResult').off('click').on('click', '.pagination li a', a => {
        // Entsprechend die gewählte Seite der Ergebnisliste abrufen
        let requestGet: requestGetType = {
            REQUEST_TOKEN: $('input[name=REQUEST_TOKEN]').val().toString(),
            oui: $('#oui').val().toString(),
        };

        // Aufzurufende Seite ermitteln
        let nextPage = 1;
        let urlParser = new URLSearchParams(a.currentTarget.href.split('?')[1]);
        if (urlParser.has('page')) {
            nextPage = urlParser.get('page');
            if (isNaN(nextPage)) nextPage = 1;
        }

        // Ergebnisliste abrufen
        searchForVendor(requestGet.oui, nextPage, requestGet.REQUEST_TOKEN);

        a.preventDefault();
    });
};
